var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.wrapper_component,{tag:"component",attrs:{"title":_vm.title}},[_c('v-container',{class:_vm.container_class},[(_vm.show_back_link && _vm.back_link_text && _vm.back_link_to)?_c('link-back',{staticClass:"mb-4",attrs:{"text":_vm.back_link_text,"to":_vm.back_link_to}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }